<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img  src="@/assets/images/pages/kinara_logo.svg" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8" v-if="sucess_msg ==''">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recover your two factor authentication</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your two factor authentication.</p>
                                </div>
                               <div class="forgot_wrap">
                               <div class="alert alert-warning" v-if="error_msg!=''">     
                                    {{error_msg}}
                                </div>
                                <div class="form-group">
                                <vs-input 
                                @click="error_msg=''"
                                v-validate="'required|email'"
                               data-vv-as="Email"
                               
                                placeholder="Email"
                                name="email"  
                                v-model="payload.email" 
                                class="w-full mb-8"
                                @keyup.enter="forgetPasswordAction()" />
                                
                                 <span v-show="errors.has('email')" class="text-danger">{{ errors.first('email') }}</span>
                                </div>
                               </div>
                                <vs-button type="border" to="/" class="px-4 w-full md:w-auto" >Back To Login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" :disabled="validateForm" @click="forgetPasswordAction()" >Reset</vs-button>
                            </div>
                            <div class="px-8 login-tabs-container padtb100" v-else>
                                <div class="vx-card__title mb-4">
                                    <div class="alert_messages">
                                
                                        <figure><img src="@/assets/images/pages/checked.svg" alt="register"  class="mx-auto" /></figure>
                                        <p >{{sucess_msg}} </p>

                                    </div>
                                </div>
                                <div class="login_btn">
                                        <router-link to="/login" class="primary_btn"> Login</router-link> 
                                </div>
                            </div>

                          
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
 
export default {
    computed: {
    validateForm () {
      return this.errors.any() || this.payload.email == ''
    }
  },
  data () {
    return {
      payload:{"email":''},
      error_msg:'',
      sucess_msg:'',
    }
  },
  methods:{
      
      forgetPasswordAction(){
          ///forgot-2fa
          this.$store.dispatch("auth/forgotTwoFa", this.payload)
          .then(result => {
                this.response = result.data;
                this.sucess_msg = result.message;
                // this.$vs.notify({
                //     title: 'Success',
                //     position:"top-right",
                //     text: result.message,
                //     iconPack: 'feather',
                //     icon: 'icon-alert-circle',
                //     color: 'success'
                // })
            }, error => {
                this.error_msg = error.message;
                // this.$vs.notify({
                //     title: 'Error',
                //     position:"top-right",
                //     text: error.message,
                //     iconPack: 'feather',
                //     icon: 'icon-alert-circle',
                //     color: 'danger'
                // })
            });
      },
      
      
  }
}
</script>
